import clsx from "clsx";

export default function Skeleton({ className, width, height }) {
  return <div className={clsx(`animate-pulse bg-slate-200 rounded`, width || "w-full", height || "h-5", className)} />;
}
